import React, {ReactNode} from 'react';
import cx from 'classnames';
import {CellResizeHandle} from './CellResizeHandle';
import {ColumnType} from '../types';
import {CellStyles} from '../types/CellStyles';

type Props = {
    style: CellStyles;
    componentClasses?: string;
    column: ColumnType;
    pinned: boolean;
    headerRenderer: (column: ColumnType, pined: boolean) => ReactNode;
    onCellResizeEnd: (width: number, columnId: number) => void;
};

export const HeaderCell = (props: Props) => {
    const {componentClasses, column, pinned, style, headerRenderer, onCellResizeEnd} = props;

    return (
        <div data-name={column.Name} className={cx(componentClasses)} style={style}>
            {headerRenderer(column, pinned)}
            <CellResizeHandle
                width={column.width}
                minWidth={column.minWidth}
                maxWidth={column.maxWidth}
                onResizeEnd={onCellResizeEnd}
                columnId={column.id}
            />
        </div>
    );
};
